import { render, staticRenderFns } from "./WidgetDisconnectBanner.vue?vue&type=template&id=518cf20e&scoped=true&"
import script from "./WidgetDisconnectBanner.vue?vue&type=script&lang=js&"
export * from "./WidgetDisconnectBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "518cf20e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo-agent-home/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('518cf20e')) {
      api.createRecord('518cf20e', component.options)
    } else {
      api.reload('518cf20e', component.options)
    }
    module.hot.accept("./WidgetDisconnectBanner.vue?vue&type=template&id=518cf20e&scoped=true&", function () {
      api.rerender('518cf20e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/WidgetDisconnectBanner.vue"
export default component.exports